<my-feedback
  title='选择岗位'
  [show]='show'
  [body]='employee_select'
  [bodyStyle]="{ width: '894px' }"
  (sure)='putResult()'
  (cancel)='close()'
  [sureText]='sureText'
  [cancelText]='cancelText'
>
  <ng-template #employee_select>
    <!--    如果当前模式是选择管理岗-->
    <div class='select-box flexRow pl-xl pr-xl pt-lg pb-md'>
      <div class='border-1 select-body selfRadius flexRow'>
        <div class='options-box flexFull border-right-1 flexColumn'>
          <!--            顶部title-->
          <div class='box-title pl-12 flexRow'>
            <div
              class='text-center mr-12 clickEle'
              style='width: 72px'
              [ngClass]="{ 'check-tab': !isAll }"
              (click)='isAll = false'
              *ngIf='useDutiesTpl'
            >
              模板岗位
            </div>
            <div class='clickEle text-center' style='width: 82px' [ngClass]="{ 'check-tab': isAll }"
                 (click)='isAll = true' *ngIf='showAll'>
              {{ checkTitle2 }}
            </div>
          </div>
          <!--            顶部title End-->
          <!--            中部搜索框-->
          <div class='all-width pl-md pr-md mt-12'>
            <nz-input-group [nzPrefix]='searchIcon' [nzSuffix]='clearSearchTpl' *ngIf='!isAll'>
              <input
                [ngModel]='leftSearchTpl'
                nz-input
                class='selfRadius'
                placeholder='搜索岗位模板'
                (keydown.enter)='$event.target.blur()'
                (blur)='searchTpl($event)'
              />
              <ng-template #clearSearchTpl>
                <i
                  nz-icon
                  nzType='close-circle'
                  nzTheme='outline'
                  *ngIf="leftSearchTpl != ''"
                  class='text-gray1 clickEle'
                  (click)='clearSearch()'
                ></i>
              </ng-template>
            </nz-input-group>
            <nz-input-group [nzPrefix]='searchIcon' [nzSuffix]='clearSearchDuties' *ngIf='isAll'>
              <input
                [ngModel]='leftSearchDuties'
                nz-input
                class='selfRadius'
                placeholder='搜索自定义岗位'
                (keydown.enter)='$event.target.blur()'
                (blur)='searchDuties($event)'
              />
              <ng-template #clearSearchDuties>
                <i
                  nz-icon
                  nzType='close-circle'
                  nzTheme='outline'
                  *ngIf="leftSearchDuties != ''"
                  class='text-gray1 clickEle'
                  (click)='clearSearch()'
                ></i>
              </ng-template>
            </nz-input-group>
          </div>
          <!--            中部搜索框 End-->
          <!--            底部选择框-->
          <div *ngIf='!isAll' class='all-width pl-md pr-md'>
            <div class='text-gray3 mt-12 mb-12'>{{ checkTitle }}</div>
            <nz-tree
              #nzTreeComponent
              [nzData]='dutiesTplData'
              [nzSelectedKeys]='selectTplIds'
              nzMultiple
              nzVirtualHeight='320px'
              [nzTreeTemplate]='dutiesTpl_tpl'
              (nzClick)='checkTpl($event)'
              *ngIf="showTplData.length == 0 && leftSearchTpl == ''"
            >
              <ng-template #dutiesTpl_tpl let-node>
                <div>
                  <i
                    nz-icon
                    nzIconfont='icon_institution'
                    class='structure-icon mr-sm'
                    *ngIf="node.level == 0 && node.origin['organ_type'] == 1"
                  ></i>
                  <i
                    nz-icon
                    nzIconfont='icon_equally'
                    class='structure-icon mr-sm'
                    *ngIf="node.level == 0 && node.origin['organ_type'] == 2"
                  ></i>
                  <i
                    nz-icon
                    nzIconfont='icon_company'
                    class='structure-icon mr-sm'
                    *ngIf="node.level == 0 && node.origin['organ_type'] == 3"
                  ></i>
                  <i
                    nz-icon
                    nzIconfont='icon_supply'
                    class='structure-icon mr-sm'
                    *ngIf="node.level == 0 && node.origin['organ_type'] == 4"
                  ></i>
                  <i nz-icon nzIconfont='icon_duties' class='structure-icon mr-sm' *ngIf='node.level != 0'></i>
                  {{ node.title }}
                </div>
              </ng-template>
            </nz-tree>
            <!--            检索岗位模板数据不为空-->
            <ng-container *ngIf="showTplData.length > 0 && leftSearchTpl != ''">
              <label
                nz-checkbox
                [(ngModel)]='tplCheckAll'
                class='select-item ml-12'
                (ngModelChange)='allTplCheck($event)'
                *ngIf='nzMultiple'
              >全选</label
              >
              <cdk-virtual-scroll-viewport
                [itemSize]='54'
                style='width: 100%'
                [ngStyle]="{
                  height:
                    checkTitle == '' && nzMultiple
                      ? '328px'
                      : checkTitle == '' && !nzMultiple
                      ? '296px'
                      : checkTitle != '' && nzMultiple
                      ? '284px'
                      : '258px'
                }"
              >
                <ng-container *ngFor='let item of showTplData; let index = index'>
                  <div class='employee-item pl-12 clickEle flexRow'>
                    <label
                      nz-checkbox
                      [ngModel]="selectTplIds.indexOf(item['key']) > -1"
                      (ngModelChange)="selectTpl(item['key'], index, $event)"
                      style='min-width: 16px'
                      class='mr-sm'
                      *ngIf='nzMultiple'
                    >
                    </label>

                    <div class='employee-item-info flexColumn' (click)="selectTpl(item['key'], index, $event)">
                      <div>
                        <i nz-icon nzIconfont='icon_duties' class='structure-icon mr-sm'></i>
                        {{ item['title'] }}
                      </div>
                      <div style='max-width: 370px; padding-left: 20px' class='text-gray1 mt-xs text-truncate'>
                        {{ item['path'] }}
                      </div>
                    </div>
                  </div>
                </ng-container>
              </cdk-virtual-scroll-viewport>
            </ng-container>
            <!--            检索岗位模板数据不为空 End-->
            <!--            检索岗位模板数据为空或者原始数据为空-->
            <ng-container *ngIf="(showTplData.length == 0 && leftSearchTpl != '') || dutiesTplData.length == 0">
              <div class='no-data-box'>
                <img src='assets/no-data.png' class='no-data-img' />
                <div class='text-gray2 all-width text-center'>暂无数据</div>
              </div>
            </ng-container>
            <!--            检索岗位模板数据为空或者原始数据为空-->
          </div>
          <div *ngIf='isAll' class='all-width pt-12 pl-md pr-md'>
            <nz-tree
              [nzData]='dutiesData'
              [nzSelectedKeys]='selectIds'
              nzMultiple
              nzHideUnMatched
              nzVirtualHeight='360px'
              [nzTreeTemplate]='structureTpl'
              (nzClick)='checkDuties($event)'
              *ngIf="dutiesData.length>0 && showDutiesData.length == 0 && leftSearchDuties == ''"
            >
              <ng-template #structureTpl let-node>
                <div>
                  <i
                    nz-icon
                    nzIconfont='icon_institution'
                    class='structure-icon mr-sm'
                    *ngIf="node.level == 0 && node.origin['organ_type'] == 1"
                  ></i>
                  <i
                    nz-icon
                    nzIconfont='icon_equally'
                    class='structure-icon mr-sm'
                    *ngIf="node.level == 0 && node.origin['organ_type'] == 2"
                  ></i>
                  <i
                    nz-icon
                    nzIconfont='icon_company'
                    class='structure-icon mr-sm'
                    *ngIf="node.level == 0 && node.origin['organ_type'] == 3"
                  ></i>
                  <i
                    nz-icon
                    nzIconfont='icon_supply'
                    class='structure-icon mr-sm'
                    *ngIf="node.level == 0 && node.origin['organ_type'] == 4"
                  ></i>
                  <i
                    nz-icon
                    nzIconfont='icon_jiagou'
                    class='structure-icon mr-sm'
                    *ngIf="node.level != 0 && node.origin['organ_type_extra'] == 1"
                  ></i>
                  <i
                    nz-icon
                    nzIconfont='icon_pianqu'
                    class='structure-icon mr-sm'
                    *ngIf="node.level != 0 && node.origin['organ_type_extra'] == 2"
                  ></i>
                  <i
                    nz-icon
                    nzIconfont='icon_arrive'
                    class='structure-icon mr-sm'
                    *ngIf="node.level != 0 && node.origin['organ_type'] == 1 && node.origin['organ_type_extra'] == 3"
                  ></i>
                  <i
                    nz-icon
                    nzIconfont='icon_jiagou'
                    class='structure-icon mr-sm'
                    *ngIf="node.level != 0 && node.origin['organ_type'] != 1 && node.origin['organ_type_extra'] == 3"
                  ></i>
                  <i
                    nz-icon
                    nzIconfont='icon_zu'
                    class='structure-icon mr-sm'
                    *ngIf="node.level != 0 && node.origin['organ_type_extra'] == 4"
                  ></i>
                  <i nz-icon nzIconfont='icon_duties' class='structure-icon mr-sm'
                     *ngIf="node.origin['organ_type'] == 5"></i>
                  {{ node.title }}
                </div>
              </ng-template>
            </nz-tree>
            <!--            检索自定义岗位数据不为空-->
            <ng-container *ngIf="showDutiesData.length > 0 && leftSearchDuties != ''">
              <label
                nz-checkbox
                [(ngModel)]='dutiesCheckAll'
                class='select-item ml-12'
                (ngModelChange)='allDutiesCheck($event)'
                *ngIf='nzMultiple'
              >全选</label
              >
              <cdk-virtual-scroll-viewport [itemSize]='54' style='width: 100%'
                                           [ngStyle]="{ height: !nzMultiple ? '350px' : '326px' }">
                <ng-container *ngFor='let item of showDutiesData; let index = index'>
                  <div class='employee-item pl-12 clickEle flexRow'>
                    <label
                      nz-checkbox
                      [ngModel]="selectIds.indexOf(item['key']) > -1"
                      (ngModelChange)="selectDuties(item['key'], index, $event)"
                      style='min-width: 16px'
                      class='mr-sm'
                      *ngIf='nzMultiple'
                    >
                    </label>

                    <div class='employee-item-info flexColumn' (click)="selectDuties(item['key'], index, $event)">
                      <div>
                        <i nz-icon nzIconfont='icon_duties' class='structure-icon mr-sm'></i>
                        {{ item['title'] }}
                      </div>
                      <div style='max-width: 370px; padding-left: 20px' class='text-gray1 mt-xs text-truncate'>
                        {{ item['path'] }}
                      </div>
                    </div>
                  </div>
                </ng-container>
              </cdk-virtual-scroll-viewport>
            </ng-container>
            <!--            检索自定义岗位数据不为空 End-->
            <!--            检索自定义岗位数据为空-->
            <ng-container *ngIf="(showDutiesData.length == 0 && leftSearchDuties != '') || dutiesData.length == 0">
              <div class='no-data-box'>
                <img src='assets/no-data.png' class='no-data-img' />
                <div class='text-gray2 all-width text-center'>暂无数据</div>
              </div>
            </ng-container>
            <!--            检索自定义岗位数据为空-->
          </div>
          <!--            底部选择框 End-->
        </div>
        <div class='result-box flexFull flexColumn'>
          <!--            顶部title-->
          <div class='box-title pl-12 flexRow'>
            <div>已选岗位</div>
            <div class='ml-sm text-xs text-gray1'>({{ selectIds.length }}项)</div>
            <div class='flexFull'></div>
            <div class='mr-md text-primary clickEle' (click)='clear()'>清空</div>
          </div>
          <!--            顶部title End-->
          <!--            中部搜索框-->
          <div class='all-width pl-md pr-md mt-12'>
            <nz-input-group [nzPrefix]='searchIcon'>
              <input nz-input class='selfRadius' placeholder='搜索岗位' [ngModel]='rightSearch'
                     (ngModelChange)='setRightSearch($event)' />
            </nz-input-group>
          </div>
          <!--            中部搜索框 End-->
          <div class='all-width pl-md pr-md mt-12'>
            <cdk-virtual-scroll-viewport [itemSize]='40' style='height: 362px'>
              <ng-container *ngFor='let item of selectData; let index = index'>
                <div
                  *ngIf="rightSearch == '' || item['title'].indexOf(rightSearch) > -1"
                  class='select-result-item mb-sm pl-12 flexRow pr-md'
                >
                  <i nz-icon nzIconfont='icon_duties' class='structure-icon mr-sm'></i>
                  <div class='flexFull'>{{ item['title'] }}</div>
                  <i nz-icon nzType='close-circle' nzTheme='outline' class='text-gray1 clickEle'
                     (click)='delete(item)'></i>
                </div>
              </ng-container>
            </cdk-virtual-scroll-viewport>
          </div>
        </div>
      </div>
    </div>
    <!--   如果当前模式是选择管理岗End -->
  </ng-template>
</my-feedback>
<ng-template #searchIcon>
  <i nz-icon nzIconfont='icon_search' class='text-gray1'></i>
</ng-template>
